import React from "react";
import { Tree } from "antd";
import type { TreeProps } from "antd/lib/tree";
import styled from "styled-components";
import { COLORS } from "styles/colors";
import { checkEmpty } from "utils/functions";

type RequireKeys<T, K extends keyof T> = T & { [P in K]-?: T[P] };

export type TreeSelectComponentProps = RequireKeys<
  TreeProps,
  "treeData" | "checkedKeys"
> & {
  searchKeyword?: string;
};

const TreeSelectComponent = (props: TreeSelectComponentProps): JSX.Element => {
  const { searchKeyword, ...treeProps } = props;
  const isSearchMode = !checkEmpty(searchKeyword);
  const checkStrictly = treeProps.checkStrictly ?? isSearchMode;

  return (
    <TreeContents>
      <Tree
        {...treeProps}
        checkable={treeProps.checkable ?? true}
        checkStrictly={checkStrictly}
        defaultExpandAll={treeProps.defaultExpandAll ?? true}
        autoExpandParent={treeProps.autoExpandParent ?? true}
        selectable={treeProps.selectable ?? false}
      />
    </TreeContents>
  );
};

export default TreeSelectComponent;

const TreeContents = styled.div`
  .ant-tree {
    background: none;
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
  .ant-tree-treenode {
    padding: 0;
  }

  .ant-checkbox .ant-checkbox-inner,
  .ant-tree-checkbox .ant-tree-checkbox-inner {
    border-radius: 2px;
    border: 1px solid #acacac;
  }

  .ant-checkbox-checked .ant-checkbox-inner,
  .ant-tree-checkbox-checked .ant-tree-checkbox-inner {
    background-color: ${({ theme }) => theme.COLORS.SELECTED};
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner,
  .ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner {
    border: none;
    position: relative;
    background: ${COLORS.GREEN} no-repeat center center;

    ::after {
      content: "";
      display: block;
      width: 10px;
      border: solid white;
      border-width: 2px 0 0 0;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: none;
      height: 0;
    }
  }

  .ant-tree-list-scrollbar-vertical {
    width: 6px !important;
  }
  .ant-tree-list-scrollbar-thumb {
    background: ${({ theme }) =>
      theme.value === "light" ? COLORS.LIGHTGRAY : "#545E77"} !important;
  }
`;
